export default __webpack_public_path__ + "ad1a3b742f288d415783ac1798ec5556.svg";